// extracted by mini-css-extract-plugin
module.exports = {"appBoar":"AppBoar_appBoar__1YQPE","appBoar_tab":"AppBoar_appBoar_tab__2LY5n","appBoar_content":"AppBoar_appBoar_content__1aaaR","appBoar_item":"AppBoar_appBoar_item__10AXI"};